import { useState, useRef, useEffect } from "react";
import { 
  get_budget_list, 
  getInvoicesBySchemeId, 
  getReimbursementBySchemeId, 
  getAllocationBudgetBySchemeId,
  getBeneficiaryReappropriationBySchemeId,
  getSalaries,
  update_scheme_status,
  fetchBudgetSurrenderAcceptedList,
  fetchBudgetSurrenderDoneList,
  getSubheadExpenses,
  fetchActivityExpenseBreakup,
  getActivity, getSubActivity,
} from "../../../helper/Api";
import { 
  useSelector } from "react-redux";
import { toast } from "react-toastify";
import SchemeBankModal from "./SchemeComponents/BankModal";
import SchemeTotalSideBar from "./SchemeComponents/SideTotalBar";
import SchemeLedgerOverlay from "./SchemeComponents/LedgerOverlay";
import SchemeDetailsOverlay from "./SchemeComponents/SchemeDetailsOverlay";
import { Link, useNavigate } from "react-router-dom";
import ExpenseDetails from "./SchemeComponents/ExpenseDetails";
import UnderTabComponents from "./SchemeComponents/UnderTabComponents";
import ActivityComponent from "./SchemeComponents/ActivityComponent";
import SubactivityComponent from "./SchemeComponents/SubactivityComponent";
import { AddCommasToAmount } from "../../../helper/Utils";

export function SchemesList({ 
  listType, 
  schemesList, 
  setSchemesList, // Add this
  financialYearStats, 
  setLoading, 
  department_id, 
  fetchSchemes,
  setFilterApplied
}) {
  const { financialYears, authData } = useSelector((state) => state.authData);
  const [activeCard, setActiveCard] = useState([]);
  const [activeSubCard, setActiveSubCard] = useState("");
  const [subHeadAccordion, setSubHeadAccordion] = useState(true);
  const globalDateId = localStorage.getItem("globalDateId");
  const [overlay, setOverlay] = useState(true);
  const [overlayDropDown, setOverlayDropDown] = useState(false);
  const handleClose = () => setOpen(false);
  const [open, setOpen] = useState(false);
  const [ledgerOverlay, setLedgerOverlay] = useState(true);
  const [schemeBudgetList, setSchemeBudgetList] = useState([]);
  const [activeKeys, setActiveKeys] = useState([]);
  const [schemeInvoiceList, setSchemeInvoiceList] = useState([]);
  const [schemeReimbursementList, setSchemeReimbursementList] = useState([]);
  const [schemeAllocationList, setSchemeAllocationList] = useState([]);
  const [schemeAllocatedToMeList, setSchemeAllocatedToMeList] = useState([]);
  const [budgetReappropriationList, setBudgetReappropriationList] = useState([]);
  const [schemeSalaryList, setSchemeSalaryList] = useState([]);
  const fy_list = financialYears.payload.fy_list;
  const schemeDetailsRef = useRef({});
  const [surrenderAcceptedList, setSurrenderAcceptedList] = useState([]);
  const [surrenderDoneList, setSurrenderDoneList] = useState([]);
  const [activity, setActivities] = useState([]);
  const [subActivity, setSubActivities] = useState([]);
  const [formData, setFormData] = useState({
    l2remarks: "",
    l3remarks: "",
  });
  const navigate = useNavigate();

  const formatAmount = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    return AddCommasToAmount(value);
  };
  const toggleAccordion = (key) => {
    setActiveKeys(
      (prevKeys) =>
        prevKeys.includes(key)
          ? prevKeys.filter((k) => k !== key)
          : [...prevKeys, key]
    );
  };

  const fetchActivities = async () => {
    try {
      const response = await getActivity();
      if (response.status === 200) {
        setActivities(response.data.result);
      } else {
        toast.error("Failed to fetch activities", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("Something went wrong while fetching activities!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
    };

    const fetchSubActivities = async () => {
    try {
      const response = await getSubActivity();
      if (response.status === 200) {
        setSubActivities(response.data.result);
      } else {
        toast.error("Failed to fetch sub-activities", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("Something went wrong while fetching sub-activities!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
    };

  const fetchSurrenderAccepted = async (schemeId) => {
    try {
      const response = await fetchBudgetSurrenderAcceptedList({department_id: department_id || authData.user.department_id, financial_year_id: globalDateId, scheme_id: schemeId})
      if(response.data.status) {
        setSurrenderAcceptedList(response.data.result);
      }
    }catch(error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }

  const fetchSurrenderDone = async (schemeId) => {
    try {
      const response = await fetchBudgetSurrenderDoneList({department_id: department_id || authData.user.department_id, financial_year_id: globalDateId, scheme_id: schemeId});
      if(response.data.status) {
        setSurrenderDoneList(response.data.result);
      }
    }catch(error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }

  const fetchSubheadExpenses = async (scheme_id) => {
    try {
      const response = await getSubheadExpenses({ 
        department_id: department_id || authData.user.department_id, 
        fy_id: globalDateId, 
        scheme_id: scheme_id
      });
      if(response.data.status) {
        const expenseMap = {};
        response.data.result.forEach(item => {
          expenseMap[item.id] = {
            utilization: item.utilization,
            unPaidUtilization: item.unPaidUtilization,
            pendingSettlementUtilization: item.pendingSettlementUtilization,
            underApprovalUtilization: item.underApprovalUtilization
          };
        });
        return expenseMap;
      }
    } catch(error) { 
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
      return {};
    }
  }

  const fetchActivityExpense = async (scheme_id) => {
    try {
      const response = await fetchActivityExpenseBreakup({ 
        department_id: department_id || authData.user.department_id, 
        fy_id: globalDateId, 
        scheme_id: scheme_id
      });
      if(response.data.status) {
        return response.data.result;
      }
    } catch(error) { 
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
      return {};
    }
  }

  const handleSchemeDetailView = (data) => {
    schemeDetailsRef.current = data;
    setFormData({
      l2remarks: data?.l2remarks || "",
      l3remarks: data?.l3remarks || "",
    });
    setOverlay(false);
  }
  const bankDetailsRef = useRef({});
  const handleBankDetailModal = (bankDetails) => {
    bankDetailsRef.current = bankDetails;
    setOpen(true);
  }
  const handleSchemeLedgerOverlay = async (data) => {
    setLoading(true);
    const schemeId = data.id;
    const deptId = department_id || authData.user.department_id;
    await Promise.all([
      fetchSchemeInvoiceList(schemeId),
      fetchSchemeBudgetList(schemeId),
      fetchBeneficiaryReimbursementBySchemeId(schemeId),
      fetchAllocationBudgetsBySchemeId(schemeId, deptId),
      fetchAllocationBudgetsBySchemeId(schemeId, null, deptId),
      fetchBudgetReappropriationBudgetList(schemeId),
      fetchSalaryList(schemeId),
      fetchSurrenderAccepted(schemeId),
      fetchSurrenderDone(schemeId)
    ]);
    schemeDetailsRef.current = data;
    setLoading(false);
    setLedgerOverlay(false);
  }

  const mainCardSwitch = async (val1, val2, val3, scheme_id) => {
    const scheme = schemesList.find(scheme => scheme.id === scheme_id);
    if(scheme) {
      
      const hasUtilizationData = scheme.sub_head_list.some(subhead => subhead.utilization);
      
      if(!hasUtilizationData) {
        setLoading(true);
        // Fetch both APIs
        const [expenseMap, expenseActivity] = await Promise.all([
          fetchSubheadExpenses(scheme_id),
          fetchActivityExpense(scheme_id)
        ]);
        
        // Create a map for activity utilization by subhead id
        const activityMap = {};
        const activityUnderApprovalMap = {};
        const activityUnpaidUtilizationMap = {};
        if(expenseActivity && Array.isArray(expenseActivity)) {
          expenseActivity.forEach(item => {
            activityMap[item.id] = item.activity_utilization || [];
            activityUnderApprovalMap[item.id] = item.under_approval_utilization || [];
            activityUnpaidUtilizationMap[item.id] = item.unpaid_utilization || [];
          });
        }
        
        // Update schemesList immutably
        setSchemesList(prevSchemes => {
          const updatedSchemes = prevSchemes.map(s => {
            if(s.id === scheme_id) {
              return {
                ...s,
                sub_head_list: s.sub_head_list.map(subhead => ({
                  ...subhead,
                  activityUtilization: activityMap[subhead.id] || [],
                  activityUnderApprovalUtilization: activityUnderApprovalMap[subhead.id] || [],
                  activityUnpaidUtilization: activityUnpaidUtilizationMap[subhead.id] || [],
                  utilization: expenseMap[subhead.id]?.utilization || null,
                  unPaidUtilization: expenseMap[subhead.id]?.unPaidUtilization || null,
                  pendingSettlementUtilization: expenseMap[subhead.id]?.pendingSettlementUtilization || null,
                  underApprovalUtilization: expenseMap[subhead.id]?.underApprovalUtilization || null
                }))
              };
            }
            return s;
          });
          
          console.log('Updated schemes:', updatedSchemes);
          return updatedSchemes;
        });
        setLoading(false);
      }
    }
    
    setActiveCard((prev) => {
      let updated = [...prev];
      updated = updated.filter(item => item !== val2 && item !== val3);
      if (!updated.includes(val1)) {
        updated.unshift(val1);
      }
      return updated;
    });
};

  const openSubAccordian = (val) => {
    setActiveKeys((prevKeys) => [...prevKeys, val]);
  };
  const closeSubAccordian = (val) => {
    setActiveKeys((prevKeys) => prevKeys.filter((key) => key !== val));
  }

  const fetchSchemeBudgetList = async (scheme_id) => {
    try {
      const response = await get_budget_list({ scheme_id: scheme_id, fy_id: globalDateId, department_id: department_id || authData.user.department_id }, 0);
      if (response.data.status) {
        setSchemeBudgetList(response.data.budgets);
      } else {
        toast.error(response.data.error, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }

  const fetchSchemeInvoiceList = async (scheme_id) => {
    try {
      const response = await getInvoicesBySchemeId({ 
        scheme_id, 
        fy_id: globalDateId, 
        department_id: department_id || authData.user.department_id
      });
      if (response.data.status) {
        setSchemeInvoiceList(response.data.invoices);
      } else {
        toast.error(response.data.error, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }

  const fetchSalaryList = async (scheme_id) => {
    try {
      const response = await getSalaries({ scheme_id, fy_id: globalDateId, department_id: department_id || authData.user.department_id, approveonly: true });
      if (response.data.status) {
        setSchemeSalaryList(response.data.result);
      } else {
        toast.error(response.data.error, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }

  const fetchBeneficiaryReimbursementBySchemeId = async (scheme_id) => {
    try {
      const response = await getReimbursementBySchemeId({ scheme_id, fy_id: globalDateId, department_id: department_id || authData.user.department_id });
      if (response.data.status) {
        setSchemeReimbursementList(response.data.result);
      } else {
        toast.error(response.data.error, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }

  const fetchAllocationBudgetsBySchemeId = async (scheme_id, parent_department_id=null, department_id=null) => {
    try {
      const response = await getAllocationBudgetBySchemeId({scheme_id, fy_id: globalDateId, parent_department_id, department_id});
      if (response.data.status) {
        if(!parent_department_id && department_id) {
          setSchemeAllocatedToMeList(response.data.result)
        } else {
          setSchemeAllocationList(response.data.result);
        }
      } else {
        toast.error(response.data.error, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    }catch(error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }
  
  const fetchBudgetReappropriationBudgetList = async (scheme_id) => {
    try {
      const response = await getBeneficiaryReappropriationBySchemeId({ scheme_id: scheme_id, fy_id: globalDateId, department_id: department_id || authData.user.department_id });
      if (response.data.status) {
        setBudgetReappropriationList(response.data.result);
      } else {
        toast.error(response.data.error, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    }catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }

  const update_scheme_status_by_id = async (scheme_id, schemeStatus) => {
        if (scheme_id && schemeStatus) {
          setLoading(true);
            let post_data = {};
            if (authData.user.user_type === 'l3') {
                post_data = {
                    "l3_status": schemeStatus,
                    "scheme_id": scheme_id,
                    "l3remarks": formData.l3remarks
                };
            } else if (authData.user.user_type === 'l2') {
                post_data = {
                    "l2_status": schemeStatus,
                    "scheme_id": scheme_id,
                    "l2remarks": formData.l2remarks
                };
            }
            const { data } = await update_scheme_status(post_data);
            if (data.status) {
              setLoading(false);
                toast.success(data.message, {
                    position: toast.POSITION.TOP_CENTER
                });
                await fetchSchemes();
                setOverlay(true);
                
            } else {
              setLoading(false);
              setOverlay(true);
                toast.error(data.message, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        }
    }

  const approvalHandler = async (e, scheme_id, schemeStatus) => {
    e.preventDefault();
    try {
      await update_scheme_status_by_id(scheme_id, schemeStatus);
    }catch(error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }

  const handleSchemFormData = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFormData({ ...formData, [name]: value });
  }

  useEffect(() => {
    fetchActivities();
    fetchSubActivities();
  }, []);


  return (
    <>
      <div className="row m-0 p-0">
        <div className="col-9 m-0 p-0">
          {
            schemesList.length && schemesList.map(e => (
              <div
                  className="bg-white border-Prime-100 my-2 p-0"
                  style={{ borderRadius: "8px" }}
                >
                  <div
                    className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden "
                    style={{ borderRadius: "8px 8px 0 0" }}
                  >
                    {/* ======================card header================== */}
                    <span
                      className="fs-14px white-space-nowrap overflow-x-hidden d-flex justify-content-between align-items-center gap-2 p-0 m-0 w-100"
                      style={{ width: "95%", fontStyle: "italic" }}
                    >
                      {/* =======================card header====================== */}
                      <span
                        className="fs-14px white-space-nowrap overflow-x-hidden"
                        style={{ width: "95%", fontStyle: "italic" }}
                      >
                        <span className="fw-500 text-secondary-100">
                          Scheme Id {e.code}-{e.name}
                        </span>
                      </span>
                      <span className="d-flex gap-2 p-0 m-0 justify-self-end align-items-center">
                        <i
                          className="icon-remove_red_eye cursor-pointer"
                          onClick={() => handleSchemeDetailView(e)}
                        ></i>
                        <i
                          className="icon-account_balance_wallet cursor-pointer" style={{color: "#f30000"}}
                          onClick={() => handleSchemeLedgerOverlay(e)}
                        ></i>
                      </span>
                    </span>
                  </div>

                  {/* ================== card body ========================= */}

                  <div className="row py-2 px-3">
                    <div className="row">
                      <div className="row m-0 p-0">
                        <div className="d-flex flex-column justify-content-center py-2 col-12 col-md-6 col-lg-3">
                          <div className="d-flex gap-2 justify-content-between align-items-center">
                            <span className="text-black-60 fs-12px">
                              <span className="me-2">Provisional Budget</span>
                              {fy_list?.map((val, ind) => {
                                return Number(val?.id) == Number(globalDateId) && val?.year;
                              })}
                            </span>
                          </div>
                          <span className="fw-500 fs-14px">
                            {formatAmount(e.total_provisional_budget)}
                          </span>
                        </div>

                        <div className="d-flex flex-column justify-content-center py-2 col-12 col-md-6 col-lg-3">
                          <div className="d-flex gap-2 justify-content-between align-items-center">
                            <span className="text-black-60 fs-12px">
                              Released FY{" "}
                              {fy_list?.map((val, ind) => {
                                return Number(val?.id) == Number(globalDateId) && val?.year;
                              })}
                            </span>
                            <i className="icon-launch text-link"></i>
                          </div>
                          <span className="fw-500 fs-14px">
                            {formatAmount(e.total_budget)}
                          </span>
                        </div>

                        <div className="d-flex flex-column justify-content-center py-2 col-12 col-md-6 col-lg-3">
                          <div className="d-flex gap-2 justify-content-between align-items-center">
                            <span className="text-black-60 fs-12px">
                              Previous FY Balance (Opening)
                            </span>
                            <i className="icon-info"></i>
                          </div>
                          <span className="fw-500 fs-14px">
                            {formatAmount(e.prevYearBalance)}
                          </span>
                        </div>

                        <div className="d-flex flex-column justify-content-center py-2 col-12 col-md-6 col-lg-3">
                          <div className="d-flex gap-2 justify-content-between align-items-center">
                            <span className="text-black-60 fs-12px">
                              Total Balance (Opening)
                            </span>
                            <i className="icon-info"></i>
                          </div>
                          <span className="fw-500 fs-14px text-success-100">
                            {formatAmount(e.balance)}
                          </span>
                        </div>

                      </div>

                      <div className="col-12 col-md-6 col-lg-3 d-flex flex-column justify-content-center py-2">
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="text-black-60 fs-12px">
                            Under approval
                          </span>
                          <i className="icon-launch text-link"></i>
                        </div>
                        <span className="fw-500 fs-14px">
                          {formatAmount(e.pending_budget)}
                        </span>
                      </div>

                      <div className="col-12 col-md-6 col-lg-3 d-flex flex-column justify-content-center py-2">
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="text-black-60 fs-12px">Sanction</span>
                          <i className="icon-launch text-link"></i>
                        </div>
                        <span className="fw-500 fs-14px">
                          {formatAmount(e.utilised_budget)}
                        </span>
                      </div>

                      <div className="col-12 col-md-6 col-lg-3 d-flex flex-column m-0 justify-content-center py-2 px-1 ">
                        <div className="d-flex p-0 m-0 justify-content-between align-items-center ">
                          <span className="text-black-60 fs-12px">
                            Previous FY Balance (Closing)
                          </span>
                          <i className="icon-info"></i>
                        </div>
                        <span className="fw-500 fs-14px">
                          {formatAmount(e.prev_year_pending_balance)}
                        </span>
                      </div>

                      <div className="col-12 col-md-6 col-lg-3 d-flex flex-column justify-content-center py-2 bg-success-20">
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="text-black-60 fs-12px">
                            Total Balance (Closing)
                          </span>
                          <i className="icon-info"></i>
                        </div>
                        <span className="fw-500 fs-14px text-success-100">
                          {formatAmount(e.balance)}
                        </span>
                      </div>

                    </div>

                    <div className="m-0 d-flex justify-content-between align-items-center mt-2">
                      <div className="d-flex gap-2 align-items-center">
                        <button className={`${(e.l2_status === '1') ? 'bg-success-20' : (e.l2_status === '0') ? 'bg-warning-20' : 'bg-danger-20'} rounded-1 border-0 px-2 py-1 fs-12px d-flex  justify-content-between align-content-center gap-1`}
                        onClick={() => {
                          if (Number(e.l2_status) === 0 && authData.user.user_type === 'l2') {
                            handleSchemeDetailView(e);
                          }
                        }}
                        >
                          L2{" "}
                          <i className={`${(e.l2_status === '1') ? 'icon-verified text-success-100' : (e.l2_status === '0') ? 'icon-warning_amber text-warning-100' : 'icon-warning_amber text-danger-100'} fs-16px`}></i>
                        </button>
                        <button className={`${(e.l3_status === '1') ? 'bg-success-20' : (e.l3_status === '0') ? 'bg-warning-20' : 'bg-danger-20'} rounded-1 border-0 px-2 py-1 fs-12px d-flex  justify-content-between align-content-center gap-1`}
                        onClick={() => {
                          if (Number(e.l3_status) === 0 && authData.user.user_type === 'l3') {
                            handleSchemeDetailView(e);
                          }
                        }}
                        >
                          L3{" "}
                          <i className={`${(e.l3_status === '1') ? 'icon-verified text-success-100' : (e.l3_status === '0') ? 'icon-warning_amber text-warning-100' : 'icon-warning_amber text-danger-100'} fs-16px`}></i>
                          
                        </button>
                        {
                          e?.attachments?.map(doc => (
                            <a href={doc.file_url} target="_blank" style={{color: 'black'}}><i className="icon-picture_as_pdf fs-18px"></i></a>
                          ))
                        }
                      </div>

                      <div className="d-flex gap-3 align-items-center">
                        {
                          ((e.l2_status === '2' || e.l3_status === '2') && authData.user.user_type === 'l1') && (<>
                            <Link to={`/edit-scheme/${e.id}`} className="text-decoration-none" title="Edit Scheme">
                              <i className="icon-edit text-success-100"></i>
                            </Link>
                            {/* <i className="icon-delete_outline text-danger-100"></i> */}
                          </>) 
                        }
                      </div>
                    </div>

                    <div>
                      {/* =======================buttons ====================== */}
                      <hr className="my-2" />

                      <div className="pb-2 d-flex justify-content-between text-secondary-50 px-4">
                        <button
                          onClick={() => mainCardSwitch(`subhead_${e.id}`, `activity_${e.id}`, `subactivity_${e.id}`, e.id)}
                          className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1 rounded-4 ${
                            activeCard.includes(`subhead_${e.id}`) ? "bg-secondary-20" : "bg-white"
                          } `}
                        >
                          {activeCard.includes(`subhead_${e.id}`) ? (
                            <i className="icon-remove_circle_outline"></i>
                          ) : (
                            <i className="icon-add_circle_outline"></i>
                          )}
                          Sub head
                        </button>
                          {
                            Number(e.is_activity_active) === 1 && <> <button
                          onClick={() => mainCardSwitch(`activity_${e.id}`,`subhead_${e.id}`, `subactivity_${e.id}`, e.id)}
                          className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4 ${
                            activeCard.includes(`activity_${e.id}`) ? "bg-secondary-20" : "bg-white"
                          } `}
                        >
                          {activeCard.includes(`activity_${e.id}`) ? (
                            <i className="icon-remove_circle_outline"></i>
                          ) : (
                            <i className="icon-add_circle_outline"></i>
                          )}
                          Activity
                        </button>
                        <button
                          onClick={() => mainCardSwitch(`subactivity_${e.id}`,`activity_${e.id}`,`subhead_${e.id}`, e.id)}
                          className={` ${
                            activeCard.includes(`subactivity_${e.id}`) ? "bg-secondary-20" : "bg-white"
                          } border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}>
                          {activeCard.includes(`subactivity_${e.id}`) ? (
                            <i className="icon-remove_circle_outline"></i>
                          ) : (
                            <i className="icon-add_circle_outline"></i>
                          )}
                          Sub-Activity
                        </button></>
                        }

                      </div>



                      {/* ===============================child datas============================== */}

                      {activeCard.includes(`subhead_${e.id}`)  && (
                        <div className="subhead">
                          {/* under tabs component */}
                          <UnderTabComponents prefix={"subhead"} identifier={e.id} setActiveSubCard={setActiveSubCard} activeSubCard={activeSubCard} />
                          <div className="row">
                            <div className="row pt-2 m-0">
                              <div className="col-3 d-flex justify-content-between align-items-center">
                                <span className="text-black-60 fs-12px">
                                  Sub Head Under Approval
                                </span>
                              </div>
                              <div className="col-3 d-flex justify-content-between align-items-center">
                                <span className="text-black-60 fs-12px">
                                  FY{" "}
                                  {fy_list?.map((val, ind) => {
                                    return val?.id == globalDateId && val?.year;
                                  })}
                                </span>
                              </div>
                              <div className="col-3 d-flex justify-content-between align-items-center">
                                <span className="text-black-60 fs-12px">
                                  Previous FY
                                </span>
                                <i className="icon-info"></i>
                              </div>
                              <div className="col-3 d-flex justify-content-between align-items-center">
                                <span className="text-black-60 fs-12px">Total</span>
                              </div>
                            </div>
                            {
                              e.sub_head_list.map(subhead => (
                                <div className="row pb-2 m-0">
                                  <div className="col-3 d-flex align-items-center">
                                    {activeKeys.includes(`subaccordian_${subhead.id}`) ? (
                                      <i
                                        className="icon-keyboard_arrow_down cursor-pointer"
                                        onClick={() => closeSubAccordian(`subaccordian_${subhead.id}`)}
                                      ></i>
                                    ) : (
                                      <i
                                        className="icon-keyboard_arrow_right cursor-pointer"
                                        onClick={() => openSubAccordian(`subaccordian_${subhead.id}`)}
                                      ></i>
                                    )}
                                    <span className="fs-14px fw-500">{subhead.name}</span>
                                  </div>
                                  <div className="col-3 d-flex justify-content-between align-items-center">
                                    <span className="fs-14px fw-500">
                                      {formatAmount(subhead.budget)}
                                    </span>
                                  </div>
                                  <div className="col-3 d-flex justify-content-between align-items-center">
                                    <span className="fs-14px fw-500">
                                      {formatAmount(subhead.pervious_year_budget)}
                                    </span>
                                  </div>
                                  <div className="col-3 d-flex justify-content-between align-items-center">
                                    <span className="fs-14px fw-500 text-success-100">
                                      {Number(subhead.budget) + Number(subhead.pervious_year_budget)}
                                    </span>
                                  </div>

                                  {activeKeys.includes(`subaccordian_${subhead.id}`) && (
                                    <div>
                                      {activeSubCard === `under_approval_subhead_${e.id}` && (
                                        <ExpenseDetails utilization={subhead?.underApprovalUtilization} />
                                      )}

                                      {activeSubCard === `sanction_subhead_${e.id}` && (
                                        <ExpenseDetails utilization={subhead?.utilization} />
                                      )}

                                      {activeSubCard === `pending_payments_subhead_${e.id}` && (
                                        <ExpenseDetails utilization={subhead?.unPaidUtilization} />
                                      )}

                                      {activeSubCard === `pending_bank_settlements_subhead_${e.id}` && (
                                        <ExpenseDetails utilization={subhead?.pendingSettlementUtilization} />
                                      )}
                                    </div>
                                  )}
                                </div>
                              ))
                            }
                          </div>
                        </div>
                      )}
                      {activeCard.includes(`activity_${e.id}`) && (
                        <div className="subhead">
                          <UnderTabComponents prefix={"activity"} identifier={e.id} setActiveSubCard={setActiveSubCard} activeSubCard={activeSubCard} />
                          {/* activity data will visible here */}
                          {activeSubCard === `under_approval_activity_${e.id}` && 
                            e.sub_head_list.map((subhead, index) => (
                              <ActivityComponent 
                                key={`activity_${subhead.id}_${index}`}
                                data={subhead?.activityUnderApprovalUtilization}
                                activeSubCard={activeSubCard} 
                                setSubHeadAccordion={setSubHeadAccordion} 
                                subHeadAccordion={subHeadAccordion} 
                                fy_list={fy_list} 
                                globalDateId={globalDateId}
                                activity={activity}
                                subheadName={subhead.name}
                                subheadId={subhead.id}
                              />
                            ))
                          }

                          {activeSubCard === `sanction_activity_${e.id}` && 
                            e.sub_head_list.map((subhead, index) => (
                              <ActivityComponent 
                                key={`activity_${subhead.id}_${index}`}
                                data={subhead?.activityUtilization}
                                activeSubCard={activeSubCard} 
                                setSubHeadAccordion={setSubHeadAccordion} 
                                subHeadAccordion={subHeadAccordion} 
                                fy_list={fy_list} 
                                globalDateId={globalDateId}
                                activity={activity}
                                subheadName={subhead.name}
                                subheadId={subhead.id}
                              />
                            ))
                          }

                          {activeSubCard === `pending_payments_activity_${e.id}` && 
                            e.sub_head_list.map((subhead, index) => (
                              <ActivityComponent 
                                key={`activity_${subhead.id}_${index}`}
                                data={subhead?.activityUnpaidUtilization}
                                activeSubCard={activeSubCard} 
                                setSubHeadAccordion={setSubHeadAccordion} 
                                subHeadAccordion={subHeadAccordion} 
                                fy_list={fy_list} 
                                globalDateId={globalDateId}
                                activity={activity}
                                subheadName={subhead.name}
                                subheadId={subhead.id}
                              />
                            ))
                          }
                          
                        </div>
                      )}
                      {activeCard.includes(`subactivity_${e.id}`) && (
                        <div className="subhead">
                          <UnderTabComponents prefix={"subactivity"} identifier={e.id} setActiveSubCard={setActiveSubCard} activeSubCard={activeSubCard} />
                          {activeSubCard === `under_approval_subactivity_${e.id}` && 
                            e.sub_head_list.map((subhead, index) => (
                              <SubactivityComponent 
                                key={`subactivity_${subhead.id}_${index}`}
                                data={subhead?.activityUnderApprovalUtilization}
                                activeSubCard={activeSubCard} 
                                setSubHeadAccordion={setSubHeadAccordion} 
                                subHeadAccordion={subHeadAccordion} 
                                fy_list={fy_list} 
                                globalDateId={globalDateId}
                                activity={activity}
                                subActivity={subActivity}
                                subheadName={subhead.name}
                                subheadId={subhead.id}
                              />
                            ))
                          }
                          {activeSubCard === `sanction_subactivity_${e.id}` && 
                            e.sub_head_list.map((subhead, index) => (
                              <SubactivityComponent 
                                key={`subactivity_${subhead.id}_${index}`}
                                data={subhead?.activityUtilization}
                                activeSubCard={activeSubCard} 
                                setSubHeadAccordion={setSubHeadAccordion} 
                                subHeadAccordion={subHeadAccordion} 
                                fy_list={fy_list} 
                                globalDateId={globalDateId}
                                activity={activity}
                                subActivity={subActivity}
                                subheadName={subhead.name}
                                subheadId={subhead.id}
                              />
                            ))
                          }

                          {activeSubCard === `pending_payments_subactivity_${e.id}` && 
                            e.sub_head_list.map((subhead, index) => (
                              <SubactivityComponent 
                                key={`subactivity_${subhead.id}_${index}`}
                                data={subhead?.activityUnpaidUtilization}
                                activeSubCard={activeSubCard} 
                                setSubHeadAccordion={setSubHeadAccordion} 
                                subHeadAccordion={subHeadAccordion} 
                                fy_list={fy_list} 
                                globalDateId={globalDateId}
                                activity={activity}
                                subActivity={subActivity}
                                subheadName={subhead.name}
                                subheadId={subhead.id}
                              />
                            ))
                          }
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))
          }
          


          
        </div>
      {/* ========================right side bar================= */}
        <div className="col-3 px-3 py-2 m-0">
          <SchemeTotalSideBar fy_lis={fy_list} globalDateId={globalDateId} financialYearStats={financialYearStats}/>
        </div>
      </div>

      {/* ==============================Scheme Details Overlay====================== */}
      <SchemeDetailsOverlay 
        handleOpen={handleBankDetailModal} 
        overlay={overlay}
        setOverlay={setOverlay}
        overlayDropDown={overlayDropDown}
        setOverlayDropDown={setOverlayDropDown}
        schemeDetails = {schemeDetailsRef.current}
        handleSchemFormData={handleSchemFormData}
        schemeFormData={formData}
        approvalHandler={approvalHandler}
        authData={authData}
        setLoading={setLoading}
        setFilterApplied={setFilterApplied}
      />

      {/* ==========================================modal================================= */}

      <SchemeBankModal 
        open={open} 
        handleClose={handleClose}
        bankDetails={bankDetailsRef.current}
      />

      {/* ==============================LedgerOverlay====================== */}

      <div className={`overlay ${ledgerOverlay ? "d-none" : null}  `}></div>

      <SchemeLedgerOverlay 
        toggleAccordion={toggleAccordion} 
        activeKeys={activeKeys} 
        ledgerOverlay={ledgerOverlay}
        fy_list={fy_list}
        globalDateId={globalDateId}
        setLedgerOverlay={setLedgerOverlay}
        setOverlay={setOverlay}
        overlayDropDown={overlayDropDown}
        setOverlayDropDown={setOverlayDropDown}
        schemeDetails = {schemeDetailsRef.current}
        schemeBudgetList={schemeBudgetList}
        schemeInvoiceList={schemeInvoiceList}
        schemeReimbursementList={schemeReimbursementList}
        schemeAllocationList={schemeAllocationList}
        schemeAllocatedToMeList={schemeAllocatedToMeList}
        budgetReappropriationList={budgetReappropriationList}
        schemeSalaryList={schemeSalaryList}
        surrenderAcceptedList={surrenderAcceptedList}
        surrenderDoneList={surrenderDoneList}
      />
      
    </>
  );
}
